<template>
  <div class="container">
    <h3 class="title is-3">Passwort ändern</h3>
    <div class="field">
        <label class="label">Altes Passwort</label>
        <div class="control is-expanded">
            <input class="input" type="password" v-model="oldPassword" v-on:keyup.enter="changePW" placeholder="Altes Passwort" />
        </div>
    </div>
    <div class="field">
        <label class="label">Neues Passwort</label>
        <div class="control is-expanded">
            <input class="input" type="password" v-model="password" v-on:keyup.enter="changePW" placeholder="Neues Passwort" />
        </div>
    </div>
    <div class="field">
      <label class="label">Neues Passwort wiederholen</label>
        <div class="control is-expanded">
            <input v-bind:class="{input: true, 'is-danger': password != repeatPassword}" type="password" v-model="repeatPassword" 
            v-on:keyup.enter="changePW" placeholder="Neues Passwort wiederholen" />
        </div>
    </div>
  </div>
</template>

<script>
  import rpc from '../rpc.js';
  export default {
    data() {
      return {
        password: "",
        repeatPassword: "",
        oldPassword: "",
      }
    },
    components: {
      
    },
    methods: {
      changePW() {
        if(this.password != this.repeatPassword) {
          return;
        }
        rpc.request('LoginService.UpdatePW', {name:this.$store.state.user.name, password:this.password}).then(json => {
          this.password = "";
          this.repeatPassword = "";
          this.oldPassword = "";
        })
      }
    }
  }
</script>
